export class Headline {
  public title: string;
  public icon?: any;
  public url?: string;
}
